import axios from 'axios'

const defaultUserProfile = {
  feideGrades: [],
  localGrades: [],
  subjects: [],
  preferredPrograms: []
}

const state = {
  userProfile: {
    feideGrades: [],
    localGrades: [],
    subjects: [],
    preferredPrograms: []
  }
}

const mutations = {
  UPDATE_USER_PROFILE (state, payload) {
    state.userProfile = JSON.parse(JSON.stringify(defaultUserProfile));

    payload.grades.forEach(grade => {
      if (grade.source === 'FEIDE') {
        state.userProfile.feideGrades.push(grade.code)
      }
      if (grade.source === 'LOCAL') {
        state.userProfile.localGrades.push(grade.code)
      }
    })
    payload.subjects.forEach(subject => {
      state.userProfile.subjects.push(subject.code)
    })
    state.userProfile.preferredPrograms = payload.preferredPrograms || []
  },
  UPDATE_USER_PROFILE_UPDATE_DISABLE_INDICATOR (state, payload) {
    state.userProfileLoading = payload
  }
}

const actions = {
  getUserProfile ({ commit }, userId) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId + '/profile')
      .then((response) => {
        commit('UPDATE_USER_PROFILE', response.data)
      })
      .catch(function (error) {
          throw error
        }
      )
  },
  updateUserProfile ({ commit }, userId) {
    commit('UPDATE_USER_PROFILE_UPDATE_DISABLE_INDICATOR', true)

    let request = {
      grades: state.userProfile.localGrades.map(grade => {
        return { code: grade }
      }),
      // We don't return feideGrades as these are read-only anyway
      subjects: state.userProfile.subjects.map(subject => {
        return { code: subject }
      }),
      preferredPrograms: state.userProfile.preferredPrograms
    }

    axios
      .put(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId + '/profile', request)
      .then((response) => {
        commit('UPDATE_USER_PROFILE', response.data)
      })
      .finally(() => {
        commit('UPDATE_USER_PROFILE_UPDATE_DISABLE_INDICATOR', false)
      })
  }
}

const getters = {
  userProfile: state => state.userProfile,
  userProfileLoading: state => state.userProfileLoading
}

const userProfilesModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default userProfilesModule
